module.exports = __webpack_public_path__ + "img/compensation1.f07b1768.jpg";